<template>
  <div>
    <base-card>
      <v-card-title primary-title class="pa-0">
        <h1 class="title mb-4">{{ $t('CART.CHECKOUT') }}</h1>
        <v-spacer />
        <tk-btn flat v-if="!$auth.currentUser" @click="$app.loginDialog = true" class="text-none">
          {{ $t('COMMON.LOGIN') }}
          <v-icon right size="20">fas fa-key</v-icon>
        </tk-btn>
      </v-card-title>

      <!-- Form -->
      <v-form autocomplete="off">
        <v-layout row wrap>
          <!-- First name -->
          <v-flex sm6>
            <v-text-field
              :error-messages="errors['billing.first_name']"
              v-model="form.billing.first_name"
              :label="$t('SIGNUP.FIRST_NAME')"
            />
          </v-flex>

          <!-- Last name -->
          <v-flex sm6>
            <v-text-field
              :error-messages="errors['billing.last_name']"
              v-model="form.billing.last_name"
              :label="$t('SIGNUP.LAST_NAME')"
            />
          </v-flex>

          <!-- Email -->
          <v-flex sm6>
            <v-text-field
              type="email"
              :error-messages="errors['billing.email'] || errors['register']"
              v-model="form.billing.email"
              :label="$t('COMMON.EMAIL')"
            />
          </v-flex>

          <!-- Phone -->
          <v-flex sm6>
            <v-text-field
              type="tel"
              :error-messages="errors['billing.phone']"
              v-model="form.billing.phone"
              :label="$t('SIGNUP.PHONE')"
            />
          </v-flex>

          <!-- Business related -->
          <template v-if="$cart.isBusiness">
            <v-flex sm6>
              <v-text-field
                :error-messages="errors['billing.business_name']"
                v-model="form.billing.business_name"
                :label="$t('GIFT_CARD.COMPANY_NAME')"
              />
            </v-flex>
            <v-flex sm6>
              <v-text-field
                :error-messages="errors['billing.business_id']"
                v-model="form.billing.business_id"
                :label="$t('GIFT_CARD.BUSINESS_ID')"
              />
            </v-flex>
          </template>

          <!-- Address -->
          <v-flex sm6>
            <v-text-field
              :error-messages="errors['billing.address']"
              v-model="form.billing.address"
              :label="$t('SIGNUP.ADDRESS')"
            />
          </v-flex>

          <!-- Zip-->
          <v-flex sm6>
            <v-text-field
              :error-messages="errors['billing.zip']"
              v-model="form.billing.zip"
              :label="$t('SIGNUP.ZIP')"
            />
          </v-flex>

          <!-- City -->
          <v-flex sm6>
            <v-text-field
              :error-messages="errors['billing.city']"
              v-model="form.billing.city"
              :label="$t('SIGNUP.CITY')"
            />
          </v-flex>

          <!-- Signup -->
          <v-flex sm6>
            <v-text-field disabled v-model="$cart.country.name" :label="$t('SIGNUP.COUNTRY')" />
          </v-flex>

          <!-- New account -->
          <v-flex v-if="!$auth.currentUser" sm6 pb-0>
            <v-checkbox
              :ripple="false"
              :label="$t('CHECKOUT.NEW_ACCOUNT')"
              color="primary"
              hide-details
              v-model="form.register"
            />
          </v-flex>

          <!-- Newsletter -->
          <v-flex sm6 pb-0>
            <v-checkbox
              :ripple="false"
              color="primary"
              hide-details
              v-model="form.newsletter"
              :label="$t('COMMON.NEWSLETTER_SUBSCRIBE')"
            />
          </v-flex>

          <!-- ship to another address -->
          <v-flex sm6>
            <v-checkbox
              :ripple="false"
              hide-details
              v-model="form.ship_to_another_address"
              :label="$t('CHECKOUT.SHIP_TO')"
              color="primary"
            />
          </v-flex>

          <!-- Register -->
          <v-flex sm12 v-if="form.register">
            <v-layout row wrap>
              <v-flex sm6>
                <input
                  hidden
                  type="text"
                  name="username"
                  autocomplete="usernmae"
                  v-model="form.billing.email"
                />
                <v-text-field
                  :error-messages="errors.password"
                  v-model="form.password"
                  :label="$t('COMMON.PASSWORD')"
                  type="password"
                  autocomplete="new-password"
                  required
                />

                  <small>{{ $t("ACCOUNT.PASSWORD_REQUIREMENTS") }}</small>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  v-model="form.password_confirmation"
                  :label="$t('SIGNUP.REPEAT_PASSWORD')"
                  type="password"
                  autocomplete="new-password"
                  required
                />
              </v-flex>
            </v-layout>
          </v-flex>

          <template v-if="form.ship_to_another_address">
            <v-flex xs12 py-0 mt-3>
              <div class="subheading font-weight-bold">{{ $t('CART.SHIPPING_ADDRESS') }}</div>
            </v-flex>

            <!-- First name -->
            <v-flex sm6>
              <v-text-field
                :error-messages="errors['shipping.first_name']"
                v-model="form.shipping.first_name"
                :label="$t('SIGNUP.FIRST_NAME')"
              />
            </v-flex>

            <!-- last name -->
            <v-flex sm6>
              <v-text-field
                :error-messages="errors['shipping.last_name']"
                v-model="form.shipping.last_name"
                :label="$t('SIGNUP.LAST_NAME')"
              />
            </v-flex>

            <!-- email -->
            <v-flex sm6>
              <v-text-field
                type="email"
                :error-messages="errors['shipping.email']"
                v-model="form.shipping.email"
                :label="$t('COMMON.EMAIL')"
              />
            </v-flex>

            <!-- Tel -->
            <v-flex sm6>
              <v-text-field
                type="tel"
                :error-messages="errors['shipping.phone']"
                v-model="form.shipping.phone"
                :label="$t('SIGNUP.PHONE')"
              />
            </v-flex>

            <!-- address -->
            <v-flex xs12>
              <v-text-field
                :error-messages="errors['shipping.address']"
                v-model="form.shipping.address"
                :label="$t('SIGNUP.ADDRESS')"
              />
            </v-flex>

            <!-- zip -->
            <v-flex sm6>
              <v-text-field
                :error-messages="errors['shipping.zip']"
                v-model="form.shipping.zip"
                :label="$t('SIGNUP.ZIP')"
              />
            </v-flex>

            <!-- city -->
            <v-flex sm6>
              <v-text-field
                :error-messages="errors['shipping.city']"
                v-model="form.shipping.city"
                :label="$t('SIGNUP.CITY')"
              />
            </v-flex>
          </template>

          <!-- Shipping method -->
          <v-flex sm12 mt-4>
            <v-layout>
              <v-flex py-0 pr-1 shrink>
                <div class="subheading font-weight-bold">{{ $t('CART.SHIPPING_METHOD') }}</div>
              </v-flex>
              <v-flex pa-0>
                <v-tooltip dark top max-width="300px">
                  <template v-slot:activator="{ on }">
                    <v-icon size="18" color="primary" v-on="on">fas fa-info-circle</v-icon>
                  </template>
                  <span>{{ shippingMethodTooltip }}</span>
                </v-tooltip>
              </v-flex>
            </v-layout>

            <v-radio-group
              v-if="is_pickup_available !== undefined"
              v-model="form.delivery_method"
              :error-messages="errors.delivery_method"
              row
            >
              <v-radio
                v-if="is_pickup_available"
                :disabled="!is_pickup_available"
                :label="$t('CHECKOUT.PICK_UP')"
                value="pick-up"
                color="primary"
              />
              <v-radio :label="$t('CHECKOUT.DOOR_TO_DOOR')" value="door-to-door" color="primary" />
            </v-radio-group>
          </v-flex>

          <v-flex sm12>
            <v-textarea
              :label="$t('CHECKOUT.ORDER_NOTES')"
              :hint="$t('CHECKOUT.ORDER_NOTES_DESC')"
              :error-messages="errors.notes"
              v-model="form.notes"
              auto-grow
              rows="2"
              persistent-hint
            />
          </v-flex>

          <v-flex sm12>
            <v-textarea
              :label="$t('CHECKOUT.ARTIST_NOTES')"
              :hint="$t('CHECKOUT.ARTIST_NOTES_DESC')"
              :error-messages="errors.artist_notes"
              v-model="form.artist_notes"
              auto-grow
              rows="2"
              persistent-hint
            />
          </v-flex>
        </v-layout>
      </v-form>
      <!-- /Form-->
    </base-card>
  </div>
</template>

<script>
export default {
  props: ["form", "errors", "is_pickup_available"],

  created() {
    if (this.$auth.currentUser) this.onAuthChange(this.$auth.currentUser);
  },

  computed: {
    shippingMethodTooltip() {
      if (
        this.$cart.country.code === "FI" ||
        this.$cart.country.code === "SE"
      ) {
        return this.$t("TOOLTIP.DELIVERY_METHOD_FI_SE");
      }
      return this.$t("TOOLTIP.DELIVERY_METHOD");
    },
  },

  watch: {
    "$auth.currentUser": "onAuthChange",
    // props might be updated from checkout component
    is_pickup_available: {
      immediate: true,
      handler: function () {
        console.log("is_pickup_available watch", this.is_pickup_available);
        if (!this.is_pickup_available) {
          this.form.delivery_method = "door-to-door";
        } else {
          this.form.delivery_method = null;
        }
      },
    },
  },

  methods: {
    onAuthChange(user) {
      console.log("OnAuthChange", user);
      this.form.billing.first_name = user.firstName;
      this.form.billing.last_name = user.lastName;
      this.form.billing.email = user.email;
      this.form.billing.phone = user.phone;
      this.form.billing.address = user.addressline1;
      this.form.billing.zip = user.zip;
      this.form.billing.city = user.city;
    },
  },
};
</script>
